import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Registry from "./Registry";
import FAQ from "./FAQ";

const PageRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/registry' element={<Registry />} />
      <Route path='/faq' element={<FAQ />} />
      <Route path='*' element={<div>It looks like that page doesn't exist.</div>} />
    </Routes>
  );
};

export default PageRoutes;